export const TARGETS = {
  UPLOAD_FILE: 'createFile',
  DELETE_FILE: 'deleteFile',
  FILES: 'files'
};
